import { render, staticRenderFns } from "./AdminSubmembersSection.vue?vue&type=template&id=6b737962"
import script from "./AdminSubmembersSection.vue?vue&type=script&lang=js"
export * from "./AdminSubmembersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports